// extracted by mini-css-extract-plugin
export default {"avSettings":"tP7vDuudwF0vg3F8uwNB","notaryAlert":"VOoLSZVg7f7utv3lFZgj","test":"ZgFjPoHzR_xUV6j5OMh3"};